module.exports = {
  AuthCheck: require("./AuthCheck"),
  GetUserData: require("./GetUserData"),
  LogOut: require("./LogOut"),
};
